import {
    CreateCustomerDumpReduxState,
    CustomerDumpReportReducerDispatch,
    CustomerDumpReportReduxTypes
} from "./types";

const CREATE_CUSTOMER_DUMP_INIT_STATE: CreateCustomerDumpReduxState = {
    data: {},
    loading: false,
    error: null
};

const CreateCustomerDumpReportReducer = (
    state: CreateCustomerDumpReduxState = CREATE_CUSTOMER_DUMP_INIT_STATE,
    action: CustomerDumpReportReducerDispatch
) => {
    switch (action.type) {
        case CustomerDumpReportReduxTypes.CUSTOMER_DUMP_REPORT: {
            return {
                ...state,
                loading: true
            };
        }

        case CustomerDumpReportReduxTypes.CUSTOMER_DUMP_REPORT_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            };
        }

        case CustomerDumpReportReduxTypes.CUSTOMER_DUMP_REPORT_ERROR: {
            return {
                data: {},
                error: action.payload.error,
                loading: false
            };
        }

        default:
            return { ...state };
    }
};

export { CreateCustomerDumpReportReducer };